import { createAPIModule } from 'utility/redux/apiModuleHelpers';
// import { createSelector } from 'reselect';

const getStateSlice = (state) => state.api.project.create;

const {
	actions,
	reducer,
	sagas,
	selectors: defaultSelectors,
} = createAPIModule({
	getStateSlice,
	actionType: 'PROJECT_CREATE',
	url: '/project/create.json',
});

const selectors = {
	...defaultSelectors,
};

export { actions, reducer, sagas, selectors };
